const InputBox = (props) => {
  return (
    <input
      id={props.id}
      name={props.name}
      type={props.type}
      value={props.value !== null ? props.value : ""}
      onChange={props.onChange}
      className={props.className}
    />
  );
};

export default InputBox;
